"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InCallNotes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const room_session_1 = require("../../../context/room_session");
const rxjs_1 = require("../../../hooks/rxjs");
const model_serial_list_1 = require("./model_serial_list/model_serial_list");
const detection_helpers_1 = require("../../../util/detection_helpers");
const recent_calls_log_host_1 = require("./recent_calls_log_host");
const company_settings_1 = require("../../../context/company_settings");
const InCallNotes = () => {
    var _a;
    const roomSession = (0, room_session_1.useRoomSession)();
    const companySettings = (0, company_settings_1.useCompanySettings)();
    const roomSessionDetections = (0, room_session_1.useRoomSessionDetections)();
    const [note] = (0, rxjs_1.useObservable)(roomSession.note.roomNote);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)('');
    const handleSaveNote = (0, react_1.useCallback)((updatedNotes) => {
        roomSession.note.saveRoomNote(updatedNotes);
    }, [roomSession]);
    const dedupedDetections = (0, detection_helpers_1.dedupeDetections)(roomSessionDetections);
    const streemshots = (0, room_session_1.useStreemshotResponses)();
    const [isEditingYn, setIsEditingYn] = (0, react_1.useState)(false);
    const noteText = (_a = note === null || note === void 0 ? void 0 : note.text) !== null && _a !== void 0 ? _a : '';
    const showMarkdownYn = !isEditingYn && noteText.length > 0;
    const onEdit = (0, react_1.useCallback)(() => {
        setIsEditingYn(true);
    }, []);
    const onSave = (noteText) => {
        setErrorMessage('');
        try {
            handleSaveNote(noteText);
            setIsEditingYn(false);
        }
        catch (error) {
            setErrorMessage('Error attempting to edit note.');
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showMarkdownYn ? ((0, jsx_runtime_1.jsx)(ui_react_1.MarkDownNotes, { text: noteText, onEdit: onEdit, showTitle: false })) : ((0, jsx_runtime_1.jsx)(ui_react_1.EditableNote, { hasFootBar: false, description: "", placeholderText: 'Add notes', characterLimit: (companySettings === null || companySettings === void 0 ? void 0 : companySettings.roomNoteCharLimit) || 1700, noteText: noteText, errorMessage: errorMessage, onSave: onSave })), (0, jsx_runtime_1.jsx)(ModelSerialListWrapper, { children: (0, jsx_runtime_1.jsx)(model_serial_list_1.ModelSerialList, { modelSerialDetections: dedupedDetections, streemshots: streemshots }) }), companySettings && !(companySettings === null || companySettings === void 0 ? void 0 : companySettings.isEmbed) && ((0, jsx_runtime_1.jsx)(recent_calls_log_host_1.RecentCallsLogForHostUser, { currentRoomId: roomSession.roomId.toString() }))] }));
};
exports.InCallNotes = InCallNotes;
const ModelSerialListWrapper = ui_react_1.styled.div({
    marginTop: '40px',
});
//# sourceMappingURL=in_call_notes.js.map